// Run before App/analytics imports. The submission-only secret stays out of analytics,
// referrers, crash URLs and browser history; it is never persisted in storage.
let token = '';
export function captureAddressRequestToken() {
  if (typeof window !== 'undefined' && /^\/address-request\/?$/.test(window.location.pathname) && window.location.hash) {
    const candidate = window.location.hash.slice(1);
    token = /^[a-f0-9]{64}$/.test(candidate) ? candidate : '';
    window.history.replaceState(window.history.state, '', '/address-request');
  }
  return token;
}
captureAddressRequestToken();
